import { Component, Input, Output, EventEmitter, OnInit, HostListener, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as alertifyjs from 'alertifyjs';
import { ContactOnboardingComponent } from '../contact-onboarding/contact-onboarding.component';

@Component({
  selector: 'app-onboarding-modal',
  templateUrl: './onboarding-modal.component.html',
  styleUrls: ['./onboarding-modal.component.css']
})
export class OnboardingModalComponent implements OnInit {
  @Input() personCode: string = '';
  @Input() fromRevision: boolean = true;
  
  @Output() onComplete = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<void>();

  @ViewChild(ContactOnboardingComponent) contactOnboardingComponent?: ContactOnboardingComponent;

  constructor(
    public activeModal: NgbActiveModal
  ) {
    console.log('OnboardingModalComponent constructor');
  }

  ngOnInit() {
    console.log('OnboardingModalComponent ngOnInit', {
      personCode: this.personCode,
      fromRevision: this.fromRevision
    });
    
    // Validar que tenemos el personCode
    if (!this.personCode) {
      console.error('ERROR: personCode no está definido en OnboardingModalComponent');
      alertifyjs.error('Error: No se proporcionó código de cliente');
      this.closeModal();
    }
  }

  // Cerrar modal con tecla ESC
  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent) {
    console.log('Tecla ESC presionada, cerrando modal');
    this.closeModal();
  }

  closeModal() {
    console.log('OnboardingModalComponent closeModal');
    
    // Primero cerrar el offcanvas biométrico si está abierto
    if (this.contactOnboardingComponent) {
      console.log('Cerrando offcanvas biométrico antes de cerrar modal principal...');
      this.contactOnboardingComponent.closeBiometricOffcanvas();
    }
    
    // Luego cerrar el modal principal
    this.activeModal.close('closed');
  }

  handleOnboardingComplete(result: any) {
    console.log('OnboardingModalComponent handleOnboardingComplete', result);
    // Pasar resultado al componente padre
    this.onComplete.emit(result);
    this.activeModal.close(result);
  }

  handleOnboardingClose() {
    console.log('OnboardingModalComponent handleOnboardingClose');
    this.onClose.emit();
    this.closeModal();
  }
}
